import { createAction } from '../../../store.model';
import { ActionType } from '../transcript-import-dialog.action';

export interface Reload {
    userId: number;
    selectedUserId: number;
}

export const reload = createAction<ActionType, Reload>(
    ActionType.TC__TI__RELOAD,
);

export interface ReloadResult extends Reload {
    selectedUserName: string;
}

export const reloadResult = createAction<ActionType, ReloadResult>(
    ActionType.TC__TI__RELOAD_RESULT,
);
